<template>
  <component :is="orders" />
</template>

<script>
import InternalOrders from "./InternalOrders";
import CustomerOrders from "./CustomerOrders";

export default {
  components: {
    InternalOrders,
    CustomerOrders
  },
  computed: {
    orders() {
      return this.$store.getters.user.userInfo.type === "C"
        ? CustomerOrders
        : InternalOrders;
    }
  }
};
</script>
